import React from "react";
import "./footer.scss";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
  
      <section className="main-footer">
        <div className="custom-container">
          <div className="innerfooter">
            <div className="footerlogo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="43"
                height="26"
                viewBox="0 0 43 26"
                fill="none"
              >
                <path
                  d="M0.00514408 23.2584V12.3107C0.00514408 10.5973 1.28332 10.0861 1.92241 10.0447H3.00885C7.7023 8.77824 8.99983 5.04707 9.06191 3.3398C9.08675 1.40282 10.2725 0.959967 10.8623 0.980662H15.2702C16.3628 1.0055 16.905 2.02572 17.0395 2.53273V6.56811C17.0892 8.80308 15.1771 9.05141 14.2148 8.89621C9.76965 9.69087 8.16171 13.3662 7.91338 15.1045V24.3858C7.91338 25.2878 6.89937 25.8377 6.39236 26H2.1397C0.302056 26 -0.0490225 24.1723 0.00514408 23.2584Z"
                  fill="#ECECEC"
                />
                <path
                  d="M17.0456 23.2584V12.3107C17.0456 10.5973 18.3238 10.0861 18.9629 10.0447H20.0493C24.7428 8.77824 26.0403 5.04707 26.1024 3.3398C26.1272 1.40282 27.313 0.959967 27.9028 0.980662H32.3107C33.4033 1.0055 33.9455 2.02572 34.08 2.53273V6.56811C34.1297 8.80308 32.2175 9.05141 31.2552 8.89621C26.8101 9.69087 25.2022 13.3662 24.9539 15.1045V24.3858C24.9539 25.2878 23.9398 25.8377 23.4328 26H19.1802C17.3425 26 16.9915 24.1723 17.0456 23.2584Z"
                  fill="#ECECEC"
                />
                <path
                  d="M34.081 12.0349C34.081 10.8266 35.0605 9.84709 36.2687 9.84709H40.1684C41.3766 9.84709 42.3561 10.8266 42.3561 12.0349V23.8122C42.3561 25.0205 41.3766 26 40.1684 26H36.2687C35.0605 26 34.081 25.0205 34.081 23.8122V12.0349Z"
                  fill="#ECECEC"
                />
              </svg>
              MRKTS
            </div>
            <p className="footerpara">©{currentYear} MRKTS. All rights reserved</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
